module.exports = {"210604001":"鸭绿江街道","210604003":"金矿街道","210604004":"珍珠街道","210604005":"太平湾街道","210604102":"同兴镇","210604104":"五龙背镇","210604105":"楼房镇","210604106":"九连城镇","210604107":"汤山城镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210604.json
// module id = 499
// module chunks = 0